<template>
  <div class="archive20251009" v-if="info">
    <v-container>
      <div v-for="(info, index) in info" :key="index">
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="10" xl="8">
            <div class="heading text-h4 pl-4">{{ formatDate(info.date) }} ビジネスチャレンジメッセTOKUSHIMA2025 出展報告</div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">2025年10月9日から11日にアスティとくしまで開催された「ビジネスチャレンジメッセTOKUSHIMA2025」に出展しました．<br>スマホで誰にも気づかれず，ストレス状態変化の「気づき」を提供いたします．</div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">
                出展題目：「メンタル不調を早期発見するAIストレスチェッカー」<br>
                <a href="https://www.tokushima-u.ac.jp/ccr/file/event/messe2025_matsumoto.pdf" target="_blank">関連資料（PDF）</a>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20251009.jpg`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
// 共通のJavaScriptファイルをインポート
import commonScript from "./common/CommonScript.js";

export default {
  mixins: [commonScript], // 共通スクリプトをミックスイン
};
</script>

<style scoped>
/* 共通のCSSファイルをインポート */
@import url("./common/CommonStyles.css");
</style>
